// promo-footer — minimal attribution + Download link (F.3 simplified shell).
//
// Hardcoded URL — org slug verified against docs/superpowers/plans/update-banner
// and update-fetcher.js (`neodisa/band-way`).

const DOWNLOAD_URL = 'https://github.com/neodisa/band-way/releases/latest';

export interface PromoFooterHandle {
  unmount: () => void;
}

export function mountPromoFooter(host: Element): PromoFooterHandle {
  host.textContent = '';
  const root = document.createElement('div');
  root.className = 'rh-promo-footer';
  root.innerHTML =
    `Made with <strong>Band Way</strong> · ` +
    `<a class="promo-footer-link" href="${DOWNLOAD_URL}" target="_blank" rel="noopener">Download →</a>`;
  host.appendChild(root);

  return {
    unmount: () => {
      host.textContent = '';
    },
  };
}
